import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
} from '@angular/router';
import { AuthService, UserRole } from '../auth/auth.service';

/** Usage: { canActivate: [authGuard, roleGuard], data: { roles: ['user', 'admin'] } } */
export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const allowed = (route.data['roles'] as UserRole[] | undefined) ?? [];
  if (allowed.length === 0 || allowed.some((role) => auth.hasRole(role))) {
    return true;
  }

  return router.parseUrl(auth.homeRoute());
};
